export default "__VITE_ASSET__7dde6595__"